import React, { useState, useEffect } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { ethers } from 'ethers';
import Web3Modal from 'web3modal';

import './App.css';
import Navbar from './components/layout/Navbar';
import Landing from './pages/Landing';
import Map from './pages/Map';
import ImageForm from './pages/ImageForm';
import Image360 from './pages/Image360';
import MyNFT from './pages/MyNFT';
import { 
  CONTRACT_ADDRESS, 
  CONTRACT_ABI,
  WEATHER_API_CONSUMER_ABI,
  WEATHER_API_CONSUMER_ADDRESS
} from './contract/contractdata';

function App() {
  const [ethAddress, setethAddress] = useState('');
  const [contract, setContract] = useState();
  const [weatherContract, setWeatherContract] = useState();

  const openMetaMask = async () => {
    const web3Modal = new Web3Modal();
    const connection = await web3Modal.connect();
    const provider = new ethers.providers.Web3Provider(connection);  

    const signer = provider.getSigner();
    const address = await signer.getAddress();
    setethAddress(address);

    const c = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, signer);
    const apiConsumer = new ethers.Contract(WEATHER_API_CONSUMER_ADDRESS, WEATHER_API_CONSUMER_ABI, signer)
    setContract(c);
    setWeatherContract(apiConsumer);
  }

  useEffect(() => {
    openMetaMask()
  }, [])

  return (
    <HashRouter>
      <Navbar ethAddress={ethAddress} openMetaMask={openMetaMask} />
      <Routes>
        <Route
          path="/map"
          element={
            <Map />} />
        <Route
          path="/imageform"
          element={
            <ImageForm />} />
        <Route
          path="/mynft"
          element={
            <MyNFT ethAddress={ethAddress} />} />
        <Route
          path="/image/:id"
          element={
            <Image360 contract={contract} weatherContract={weatherContract} />} />
        <Route
          path="/"
          element={
            <Landing />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
